import React from "react";
import { Link } from "react-router-dom";

export default function HoteleriaRamallo({ bgColor }) {
  return (
    <>
      <section
        id="hoteleria"
        className={`contact-us ptb-100 ${bgColor ? "gray-light-bg" : ""}`}
      >
        <section className="team-member-section ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7 col-md-8">
                <div className="section-heading text-center mb-4">
                  <h2>HOTELERIA EXCLUSIVA</h2>
                  <h3>All inclusive</h3>
                  <p className="lead">
                  Hoteleria  exclusiva adaptada para turismo estudiantil, con tecnología de punta,todas las comodidades y servicios que los pasajeros necesitan para poder tener una estadía única e inolvidable.
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/ramallo/Ramallo-CabanasPortofino.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">Cabañas Portofino</h5>
                    <h6>Ramallo Centro</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                      <li className="list-inline-item">
                        <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to="https://www.facebook.com/PortofinoRamallo"
                        >
                          <span className="ti-facebook"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to="https://www.instagram.com/portofinocabanasyrestoramallo"
                        >
                          <span className="ti-instagram"></span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/ramallo/Ramallo-DonFrancisco.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">Hotel Don Francisco</h5>
                    <h6>Ramallo Centro</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                      <li className="list-inline-item">
                        <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to="https://www.facebook.com/hoteldonfrancisco"
                        >
                          <span className="ti-facebook"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to="https://www.instagram.com/hoteldonfrancisco/"
                        >
                          <span className="ti-instagram"></span>
                        </Link>
                      </li>
                    </ul>
                    <a
                      href="https://linktr.ee/hoteldonfrancisco"
                      target="_blank"
                      rel="noreferrer"
                      className="btn app-store-btn"
                    >
                      Ver hotel
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
